const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .statusBar": {
      display: "none",
    },
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
  container: {
    paddingTop: 4,
    height: "calc(100% - 86px)",
  },
  hideContainer: {
    display: 'none'
  }
});

export default styles;
